import React from "react";
import withTokenGroup from "../withTokenGroup";
import styles from "./index.css";
const Breadcrumbs = () => (
  <nav
    aria-label="breadcrumbs"
    className={styles.container}
    dangerouslySetInnerHTML={{
      __html: `{{#if Breadcrumbs}}
        <ol class="${styles.list}">
          {{#each Breadcrumbs}}
            <li>
              {{#if @index}}<span aria-hidden="true">›</span>{{/if}}
              {{#if Url}}
                <a href="{{Url}}">{{Label}}</a>
              {{#else}}
                {{Label}}
              {{/if}}
            </li>
          {{/each}}
        </ol>
      {{/if}}`
    }}
  />
);

export default withTokenGroup("breadcrumb", null, Breadcrumbs);
